interface params {
  object: any;
  path: string;
  value: any;
}
export const get = (object: any, path: Array<any> | string, value?: any) => {
  if (!path) return undefined;
  const pathArray = Array.isArray(path)
    ? path
    : path.split(/[,[\].]/g).filter(Boolean);
  return (
    pathArray.reduce(
      (prevObj: any, key: any) => prevObj && prevObj[key],
      object
    ) || value
  );
};
